import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReportManagerService {
    isReportSelected: BehaviorSubject<string> = new BehaviorSubject(null);
    selectedReportName: BehaviorSubject<string> = new BehaviorSubject(null);
    _selectedView: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor() {}
}
